import get from 'lodash.get';
import { SHIPPING_DEFAULT_OPTIONS } from '../services/other-shipping-options/constants';

class ShippingServiceServiceClass {
  hydrateSellerLabelProviderServices(shippingServices, sellerLabelProviders, registryShippingOptions) {
    return sellerLabelProviders.reduce((allServices, sellerLabelProvider) => {
      const { sellerLabelProviderId, labelProviderId } = sellerLabelProvider;
      const registryProvShippingOptions = registryShippingOptions.find((prov) => prov && prov.providerId.toString() === labelProviderId);
      const optionCodes = [];
      if (registryProvShippingOptions && registryProvShippingOptions.shippingOptions) {
        for (let i = 0; i < registryProvShippingOptions.shippingOptions.length; i++) {
          const oso = registryProvShippingOptions.shippingOptions[i];
          if (oso && oso.type) {
            optionCodes.push(oso.type);
          }
        }
      }
      if (optionCodes.length === 0) {
        optionCodes.push(SHIPPING_DEFAULT_OPTIONS);
      }
      const providerServices = shippingServices.filter((service) => service.labelProviderId === labelProviderId);
      return allServices.concat(
        providerServices.map((service) => ({
          ...service,
          optionCodes,
          sellerLabelProviderId,
        })),
      );
    }, []);
  }

  getPrimarySellerLabelProviderId(serviceId, services, sellerLabelProviders) {
    const labelProvider = services.find((service) => service.serviceId === serviceId);
    const labelProviderId = get(labelProvider, 'labelProviderId');
    const sellerLabelProvider = sellerLabelProviders.find(
      (provider) => provider.labelProviderId === labelProviderId && provider.isPrimaryAccount,
    );
    return get(sellerLabelProvider, 'sellerLabelProviderId');
  }

  getUniqueSellerLabelProviders(uniqueLabelProviderIds, sellerLabelProviders) {
    return uniqueLabelProviderIds.reduce((results, current) => {
      const slps = sellerLabelProviders.filter((p) => p.labelProviderId === current);
      const slp = slps.find((p) => p.isPrimaryAccount && p.walletId) || slps.find((p) => p.isPrimaryAccount) || slps[0];
      return [...results, slp];
    }, []);
  }

  buildServiceMap(services, sellerLabelProviders) {
    const serviceMap = {};
    const uniqueLabelProviderIds = [...new Set(sellerLabelProviders.map((p) => p.labelProviderId))];
    const uniqueAndDefault = this.getUniqueSellerLabelProviders(uniqueLabelProviderIds, sellerLabelProviders).map(
      (p) => p.sellerLabelProviderId,
    );
    const filteredServices = services.filter((service) => uniqueAndDefault.includes(service.sellerLabelProviderId));
    [...new Set(filteredServices.map((x) => x.labelProviderId))].forEach((labelProvider) => {
      serviceMap[labelProvider] = filteredServices.filter((service) => {
        return labelProvider === service.labelProviderId;
      });
    });
    return serviceMap;
  }
}

export const ShippingServiceService = new ShippingServiceServiceClass();
